import { useCallback } from "react";
import { UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL } from "features/AdminPanel/constants/AdminPanel.api";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { useParams } from "react-router-dom";
import { getListingUuidFromUrlParam } from "ui/pages/ThankYou/utils";

export const useContractUpload = ({
  subSectionKey,
  endPoint = UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
}) => {
  const { listing_uuid } = useParams();
  const listingId = getListingUuidFromUrlParam() || listing_uuid || "kyc";
  const { handleSectionChange } = useAccountSectionUnlocking();
  const handleChange = useCallback(
    ({ value }) => {
      const payload = {
        listing_uuid: listingId,
        feature_key: subSectionKey,
        feature_value: value,
      };
      handleSectionChange({
        endPoint,
        payload,
      });
    },
    [listingId, subSectionKey, handleSectionChange, endPoint]
  );

  const handleOnSuccessUpload = useCallback(
    async (fileLocation, uploadIndex, uploadedFiles, multiUpload) => {
      let newValue;

      if (multiUpload) {
        // Multi-upload mode: add to array or update existing
        const updatedFiles = [...uploadedFiles];

        if (uploadIndex !== undefined && uploadIndex < updatedFiles.length) {
          // Update existing file at this index
          updatedFiles[uploadIndex] = fileLocation;
        } else {
          // Add new file
          updatedFiles.push(fileLocation);
        }

        newValue = updatedFiles;
      } else {
        // Single upload mode (backward compatibility)
        newValue = fileLocation;
      }

      handleChange({ value: newValue });
    },
    [handleChange]
  );

  const onClickClose = useCallback(
    (e, indexToRemove, uploadedFiles) => {
      e.stopPropagation();
      const updatedFiles = uploadedFiles.filter(
        (_, index) => index !== indexToRemove
      );

      // If no files left, store empty string for backward compatibility
      // Otherwise store array
      const newValue = updatedFiles.length === 0 ? "" : updatedFiles;
      handleChange({ value: newValue });
    },
    [handleChange]
  );

  const onClickPdf = useCallback((e, url) => {
    if (e?.defaultPrevented) return; // Prevent Parent Button Click event
    window.open(url || "", "_blank");
  }, []);

  return {
    handleChange,
    handleOnSuccessUpload,
    onClickClose,
    onClickPdf,
    listingId,
  };
};
